"use client";

import React, {cloneElement} from "react";
import {useTracking} from "@/context/tracking.context";
import {useCookies} from "react-cookie";

interface TrackingLinkProps {
    source?: string
    children: React.ReactNode
}

export function TrackingLink({source, children}: TrackingLinkProps) {
    const [cookies] = useCookies(['location']);
    const {referrer, entryTime, entryPage, anonymousId} = useTracking();
    const childProps = React.isValidElement(children) ? (children.props as Record<string, unknown>) : null;
    if (typeof window !== "undefined" && childProps !== null && typeof childProps.href === 'string') {
        let href = new URL(childProps.href, window.location.href);
        let params = href.searchParams;
        params.set('t_aid', anonymousId);
        params.set('t_s', source ?? '');
        params.set('t_r', referrer ?? '');
        params.set('t_et', entryTime ?? '');
        params.set('t_ep', entryPage ?? '');
        params.set('t_loc', cookies.location ?? '');
        params.set('t_exit', window.location.href);
        href.search = params.toString();
        const clone = cloneElement<any>(children as any, {
            href: href.toString()
        });
        return (
            <>{clone}</>
        )
    }
    return (
        <>{children}</>
    )
}